const en = {
    "Hi":"Hi",
    "Home":"Home",
    "My_Credit":"My Credit",
    "Transaction_Records2":"Transaction Records",
    "Merchant_Center":"Merchant Center",
    "Opened_platform":"Opened platform",
    "Help_center":"Help center",
    "Collaboration_Platform":"Collaboration Platform",
    "Live_CS_":"Live CS ",
    "Customer_Hotline":"Customer Hotline",
    "Monday_to_Friday":"Monday to Friday",
    "Login_to_Security_Center":"Login to Security Center",
    "Logout":"Logout",
    "Security_center":"Security center",
    "Customer_Service":"Customer Service",
    "Login_by_QR_code":"Login by QR code",
    "login_through_Account_information":"Login by Account",
    "Enter_your_Hp_No_or_email":"Enter your Hp. No. or email",
    "Enter_the_password":"Enter the password",
    "Enter_verification_code":"Enter verification code",
    "forget_password":"forget password",
    "Login":"Login",
    "Register_an_account":"Register an account",
    "Become_a_Merchant":"Become a Merchant",
    "Other_login_methods":"Other login methods",
    "Platform_opened_function":"Platform opened function",
    "Payment_function":"Payment function",
    "Meet_the_payment_requirements":"Meet the payment requirements",
    "Multicurrency_payment_selection":"Multi-currency payment selection",
    "Supports_currency_transactions_in_China_Malaysia_Thailand_and_others":"Supports currency transactions in China, Malaysia, Thailand and others",
    "MultiCountry_Services":"Multi-Country Services",
    "Set_up_branches_in_multiple_countries_in_order_to_provide_a_good_quality_services_to_users":"Set up branches in multiple countries in order to provide a good quality services to users",
    "Security_protected":"Security protected",
    "Continuously_enhance_user_protection":"Continuously enhance user protection",
    "APP_download":"APP download",
    "Payments_transfers_etc":"Payments, transfers, etc.",
    "Effortless_APP":"Effortless APP",
    "Serving_you":"Serving you",
    "Download_A5B_Pay_APP_get_more_surprises":"Download EGC56 Pay APP, get more surprises!",
    "Download_from_the_app_store":"Download from the app store",
    "download_at_Google_play":"download at Google play",
    "Morning":"Morning,",
    "Afternoon":"Afternoon,",
    "Evening":"Evening,",
    "Last_login":"Last login",
    "Credit_balance2":"Credit balance",
    "Asia5b_pays_support_with_QR_code_scan_more_convenient_Support_RMB_Malaysian_Ringgit_and_other_currencies":"EGC56 pays support with QR code scan, more convenient. Support RMB, Malaysian Ringgit and other currencies.",
    "Bind_payment_method":"Bind payment method",
    "Add_method":"Add method",
    "Bind_payment_method2":"Bind payment method",
    "Account_navigation":"Account navigation",
    "Balance":"Balance",
    "Top_up":"Top up",
    "Withdraw":"Withdraw",
    "Minimum_withdrawal_amount":"Minimum withdrawal amount",
    "Fund_Transfer":"Fund Transfer",
    "Inquiry":"Inquiry",
    "More_currencies_selection":"M<br>o<br>r<br>e",
    "Recent_transaction_records":"Recent transaction records",
    "Transaction_records":"Transaction records",
    "Balance_record":"Balance record",
    "Classification":"Classification",
    "Date":"Date",
    "Remark":"Remark",
    "Transaction_number":"Transaction number",
    "Amount":"Amount",
    "Currency":"Currency",
    "Payment_method":"Payment method",
    "Transaction_Type":"Transaction Type",
    "Status":"Status",
    "Operate":"Operate",
    "View":"View",
    "Pay":"Pay",
    "Alipay":"Alipay",
    "WeChat":"WeChat",
    "Credit_card":"Credit card",
    "Billplz":"Billplz",
    "FPX":"FPX",
    "Processing":"Processing",
    "Pending_payment":"Pending payment",
    "Successful_transaction":"Successful transaction",
    "Refunding":"Refunding",
    "refunded":"refunded",
    "Shipped":"Shipped",
    "Transaction_failed":"Transaction failed",
    "Refund":"Refund",
    "Collect_Fund":"Collect Fund",
    "Commission_Withdraw":"Commission Withdraw",
    "Credited_Amount":"Credited Amount",
    "Auto_Debit":"Auto Debit",
    "Spend":"Spend",
    "Amount_to_be_paid":"Amount to be paid",
    "Order_payment":"Order payment",
    "Select_the_top_up_amount":"Select the top up amount",
    "Or_enter_the_amount_manually":"Or enter the amount manually",
    "Please_enter_the_amount":"Please enter the amount",
    "Alipay_processing_fee":"Alipay processing fee",
    "Please_scan_with_Alipay":"Please scan with Alipay",
    "Scan_QR_code_to_pay":"Scan QR code to pay",
    "Please_enter_the_correct_amount":"Please enter the correct amount",
    "Payment_steps":"Payment steps",
    "Complete_the_transfer":"Complete the transfer",
    "submit_application":"submit application",
    "Waiting_for_confirmation":"Waiting for confirmation",
    "Perform_mutitop_up_at_one_time_avoid_transferring_integer_amounts_such_as_RM100_RM50_etc_Adding_a_decimal_point_such_as_RM10003_or_RM49_for_easy_verification":"Perform muti-top up at one time, avoid transferring integer amounts such as RM100, RM50, etc. Adding a decimal point such as RM100.03, or RM49.99 for easy verification",
    "Account_holder":"Account holder",
    "Please_select_the_transfer_bank":"Please select the transfer bank",
    "Main_site":"Main site",
    "Transaction_notice":"In order to accelerate the transaction, we recommend that set My Intial as your EGC56 username when doing an online transfer.",
    "Transfer_completed":"Transfer completed",
    "Please_fill_in_the_transfer_information_for_the_financial_department_to_confirm_the_payment":"Please fill in the transfer information for the financial department to confirm the payment",
    "Ho_No":"Hp. No.",
    "Please_enter_the_Hp_No":"Please enter the Hp. No.",
    "Transfer_to_bank":"Transfer to bank",
    "Transfer_to_bank_account":"Transfer to bank account",
    "Please_choose_to_transfer_to_bank":"Please choose to transfer to bank",
    "Please_choose_to_transfer_to_bank_account":"Please choose to transfer to bank account",
    "Transfer_from_bank":"Transfer from bank",
    "Please_select_a_transfer_from_bank":"Please select a transfer from bank",
    "reference_number":"Reference number",
    "Please_enter_the_reference_number":"Please enter the reference number",
    "Transfer_time":"Transfer time",
    "Please_select_a_transfer_time":"Please select a transfer time",
    "Upload_receipt2":"Upload receipt",
    "Submit_top_up":"Submit top up",
    "top_up_successful":"top up successful",
    "Please_wait_patiently_for_the_verification_revert_back_a_message_once_completed_Refer_top_up_status_for_transaction_history":"Please wait patiently for the verification, revert back a message once completed. Refer top up status for transaction history.",
    "Next_top_up":"Next top up",
    "Enter_CVV2":"Enter CVV2",
    "Enter_the_correct_CVV2":"Enter the correct CVV2",
    "Enter_the_correct_transfer_time":"Enter the correct transfer time",
    "Select_the_transfer_time":"Select the transfer time",
    "Upload_receipt":"Upload receipt",
    "Submission_Failed":"Submission Failed",
    "Confirm2":"Confirm",
    "Fail_to_upload":"Fail to upload",
    "Selected_Bank":"Selected Bank",
    "Select_your_bank":"Select your bank",
    "CreditNeedAddress": "Using a credit card requires perfecting your address information, click To determine the perfect information.",
    "Credit_Card_No":"Credit Card No.",
    "Enter_Credit_Card_No":"Enter Credit Card No.",
    "YourIdType": "Your ID type",
    "Cardholders_Name":"Cardholder's Name",
    "Fill_in_cardholder_name":"Fill in cardholder name",
    "Expire_date":"Expire date",
    "Select_credit_card_expiration_time":"Select credit card expiration time",
    "I_have_read_and_agree_to_the_Credit_Card__Debit_Card_Terms_and_Conditions":"I have read and agree to the [Credit Card / Debit Card Terms and Conditions]",
    "Next_step":"Next step",
    "Top_up_successful_access_My_Credit_to_check_the_your_balance":"Top up successful, access \"My Credit\" to check the your balance",
    "Select_bank_for_transfer":"Select bank for transfer",
    "Email_address":"Email address",
    "Enter_your_email_address":"Enter your email address",
    "I_have_read_and_agree_to_the_FPX_Terms_and_Conditions":"I have read and agree to the [FPX Terms and Conditions].",
    "Enter_your_correct_email_address":"Enter your correct email address",
    "WeChat_processing_fee":"WeChat processing fee",
    "Please_scan_using_WeChat":"Please scan using WeChat",
    "Check_the_top_up_status_in_the_transaction_history":"Check the top up status in the transaction history.",
    "Changable_amount":"Changable amount",
    "Credit_Balance":"Credit Balance",
    "transaction_currency":"transaction currency",
    "Congratulations":"Congratulations!",
    "The_system_is_processing":"The system is processing",
    "Bind_account":"Bind account",
    "Unbind_it":"Unbind it",
    "Bind_now":"Bind now",
    "Username2":"Username",
    "Password":"Password",
    "Cancel":"Cancel",
    "Confirm":"Confirm",
    "Amall_Marketplace":"Amall Marketplace",
    "Shipforme":"Ship-for-me",
    "Buyforme":"Buy-for-me",
    "Live_Video":"Live Video",
    "Please_enter_username":"Please enter username",
    "Unbind_account":"Unbind account",
    "Account_binding":"Account binding",
    "Successful_operate":"Successful operate!",
    "Upload_image":"Upload image",
    "Phone_number":"Phone number",
    "Modify":"Modify",
    "Email":"Email",
    "image_supported_with_JPG_PNG_format":"image supported with JPG, PNG format!",
    "Login_password2":"Login password",
    "A5bpay_Password_to_login":"EGC56 pay Password to login",
    "Reset":"Reset",
    "Payment_password":"Payment password",
    "Password_needed_when_editing_info":"Password needed when editing info",
    "Download_APP":"Download APP",
    "4_to_20_characters_in_length":"6 to 20 characters in length",
    "4_characters_in_length":"4 characters in length",
    "Hotline":"Hotline",
    "All":"All",
    "Time_period":"Time period",
    "Start_date":"Start date",
    "End_date":"End date",
    "to":"to",
    "More_filters":"More filters",
    "Amount_range":"Amount range",
    "Enter_starting_amount":"Enter starting amount",
    "Enter_end_amount":"Enter end amount",
    "Keywords":"Keywords",
    "Enter_keywords":"Enter keywords",
    "IN":"IN",
    "OUT":"OUT",
    "last_week":"last week",
    "last_month":"last month",
    "last_three_months":"last three months",
    "Initialize_payment_password":"Initialize payment password",
    "Set_up_payment_password":"Set up payment password",
    "Confirm_payment_password":"Confirm payment password",
    "Password_consists_of_6_digits":"Password consists of 6 digits",
    "Please_enter_the_password_again":"Please enter the password again",
    "The_passwords_entered_twice_are_inconsistent":"The passwords entered twice are inconsistent!",
    "Set_up_successfully":"Set up successfully",
    "Login_failed":"Login failed",
    "checkout_counter":"checkout counter",
    "order_number":"order number",
    "yuan":"yuan",
    "Order_time":"Order time",
    "Order_details":"Order details",
    "Back_to_pay_with_balance":"Back to pay with balance",
    "Your_account_has_no_balance_please_top_up_":"Your account has no balance, please top up ",
    "Or_click_other_payment_methods_choose_Alipay_or_WeChat_pay":"Or click other payment methods, choose Alipay or WeChat pay",
    "pending_to_be_pay":"pending to be pay",
    "Your_xx_account_balance_is_insufficient_please_top_up":"Your xx account balance is insufficient, please top up!",
    "Topup_balance_select_new_currency":"Top-up balance /select new currency",
    "Other_payment_methods":"Other payment methods",
    "Please_enter_the_payment_password":"Please enter the payment password",
    "Forget_password":"Forget password?",
    "Confirm_payment":"Confirm payment",
    "Payment_failed":"Payment failed",
    "Please_select_a_payment_currency":"Please select a payment currency",
    "Account_balance_is_insufficient_please_top_up":"Account balance is insufficient, please top up",
    "Payment_successful":"Payment successful",
    "Confirmation_message":"Confirmation message",
    "Select_Payment_Method":"Select Payment Method",
    "A5bpay":"EGC56Pay",
    "Provide_best_quality_security_":"Provide best quality security ",
    "Sign_Up":"Sign Up",
    "Create_Account":"Create Account",
    "Set_login_password":"Set login password",
    "Payment_settings":"Payment settings",
    "Complete":"Complete",
    "Nationality__Region":"Nationality / Region",
    "Please_select_your_nationality__region":"Please select your nationality / region",
    "SMS_verification_code":"SMS verification code",
    "In_order_to_provide_you_with_better_financial_services_identity_information_cannot_be_changed_once_it_is_entered_and_private_information_is_strictly_confidential_without_my_permission":"In order to provide you with better financial services, identity information cannot be changed once it is entered, and private information is strictly confidential without my permission.",
    "Username":"Username",
    "Login_password":"Login password",
    "Please_enter_your_login_password":"Please enter your login password",
    "Reenter":"R]e-enter",
    "Confirm_submission":"Confirm submission",
    "Registration_success":"Registration success",
    "You_have_successfully_log_in_to_Wu_Shiyi_payment_account":"You have successfully log in to Wu Shiyi payment account!",
    "The_email_has_been_registered":"The email has been registered!",
    "please_enter_a_valid_phone_number":"please enter a valid phone number!",
    "The_phone_number_has_been_registered":"The phone number has been registered!",
    "Get_verification_code":"Get verification code",
    "Get_the_code_after_3s":"Get the code after 3s",
    "Verification_code_verified_failed":"Verification code verified failed",
    "Top_up_your_account_balance":"Top up your account balance",
    "A5b_pays_support_scan_QR_code_making_top_up_more_convenient_Support_RMB_Malaysian_Ringgit_and_other_currencies_for_topup_transactions":"EGC56 pays support scan QR code, making top up more convenient. Support RMB, Malaysian Ringgit and other currencies for top-up transactions.",
    "Top_up_now":"Top up now",
    "Processing_fee":"Processing fee",
    "Balance_withdrawal": "Balance withdrawal",
    "Service_Fee":"Service fee",
    "Rate":"Rate",
    "A_single_service_charge_is_a_minimum_of_0_1_yuan":"A single service charge is a minimum of 0.1 yuan ！",
    "Total_paid":"Total paid",
    "Merchant_order_number":"Merchant order number",
    "Counterparty_information":"Counterparty information",
    "Creation_time":"Creation time",
    "Payment_time":"Payment time",
    "End_Time":"End Time",
    "Merchant_description":"Merchant description",
    "Merchant_name":"Merchant name",
    "Tips_System_automatically_notify_the_payee_of_the_transfer_result":"Tips: System automatically notify the payee of the transfer result.",
    "Payee_phone_Number__Email_Address":"Payee phone Number / Email Address",
    "Please_enter_your_mobile_number__email_address":"Please enter your mobile number / email address",
    "Transfer_amount":"Transfer amount",
    "Please_enter_the_transfer_amount":"Please enter the transfer amount",
    "Transfer_remark":"Transfer remark",
    "Please_enter_a_transfer_remark":"Please enter a transfer remark",
    "I_have_read_and_agree_to_the_Transfer_Terms_and_Conditions":"I have read and agree to the \"Transfer Terms and Conditions\"",
    "Confirm_transferred":"Confirm transferred",
    "Successful_transfered_about_to_enter_the_Fortune_Center_page":"Successful transfered, about to enter the \"Fortune Center\" page",
    "Submitted_successfully":"Submitted successfully",
    "Continue_to_transfer":"Continue to transfer",
    "Please_enter_the_correct_transfer_amount":"Please enter the correct transfer amount",
    "Your_account_does_not_have_sufficient_balance":"Your account does not have sufficient balance",
    "Please_enter_the_payee_phone_number__email_addres":"Please enter the payee phone number / email addres",
    "Please_enter_the_correct_payee_mobile_number__email_address":"Please enter the correct payee mobile number / email address",
    "This_account_has_insufficient_balance_to_transfer_please_choose_an_account_with_a_balance_thank_you":"This account has insufficient balance to transfer, please choose an account with a balance, thank you!",
    "Basic_Information":"Basic Information",
    "Security_Settings":"Security Settings",
    "message_notification":"message notification",
    "Withdrawal_of_balance":"Withdrawal of balance",
    "Cash_withdrawal":"Cash withdrawal",
    "Please_enter_the_amount_of_cash_withdrawal":"Please enter the amount of cash withdrawal",
    "account_type":"account type",
    "Please_select_an_account_type":"Please select an account type",
    "debit_card":"debit card",
    "cardholders_ID_number":"ID number",
    "Please_enter_cardholders_ID_number":"Please enter ID number",
    "Bank_Account":"Bank Account",
    "Please_enter_your_bank_account_number":"Please enter your bank account number",
    "I_have_read_and_agree_to_the_Withdrawal_Terms_and_Conditions":"I have read and agree to the Withdrawal Terms and Conditions",
    "The_amount_of_cash_withdrawal_cannot_be_greater_than_the_balance":"The amount of cash withdrawal cannot be greater than the balance",
    "This_account_has_no_balance_to_withdraw_please_choose_an_account_with_a_balance_thank_you":"This account has no balance to withdraw, please choose an account with a balance, thank you!",
    "Withdrawal_failed":"Withdrawal failed",
    "Your_login_status_has_expired_please_log_in_again":"Your login status has expired, please log in again!",
    "Permission_error":"Permission error",
    "Data_acquisition_failed":"Data acquisition failed!",
    "Request_timed_out":"Request timed out!",
    "Incorrect_file_parameters_please_confirm_if_a_file_is_passed_in":"Incorrect file parameters, please confirm if a file is passed in",
    "The_file_format_is_not_jpg_or_png_please_confirm_the_file_format":"The file format is not jpg or png, please confirm the file format",
    "Unsupported_file_format":"Unsupported file format",
    "Browser_does_not_support_canvas":"Browser does not support canvas",
    "Browser_does_not_support_FileReader":"Browser does not support FileReader",
    "Image_load_failed":"Image load failed",
    "AddAddress": "Add Address",
    "EditAddress": "Edit Address",
    "Address_management": "Address management",
    "Name": "Name",
    "Address": "Address",
    "Tel": "Tel",
    "Operation": "Operation",
    "No_more_data": "No more data",
    "First_name": "First name",
    "Last_name": "Last name",
    "Country_code": "Country code",
    "Country": "Country",
    "Province": "Province",
    "City": "City",
    "Detailed_address": "Detailed address",
    "Zip": "Zip",
    "Set_default": "Set default",
    "After_successful_payment": "After successful payment, the selected pending order is automatically paid (optional)",
	"BillplzTips": "Billplz： instant top up to \" My Wallet\", processing fee is RM 1.50 per transaction; ",
    "EATMTips": "E-banking，ATM：within 24 hour top up to \" My Wallet\", no processing fee.",
	"Bill": 'Bill',
    "View_the_bill": 'View the bill',
    "Payment_Notes": 'Payment Notes',
    "Payment_times": 'Payment time',
    "Please_enter": 'Please enter ',
    "Please_select": 'Please select ',
    "remark": 'Remark',
    "Please_enter_remark": 'Please enter remark',
}

export default en
